// UI components
import Datepicker from "../../../../../components/ui/datepicker/datepicker"
import Timepicker from "../../../../../components/ui/datepicker/timepicker"
import { PlusIcon, TrashIcon } from "../../../../../utils/svgs-v2"

// Generate a short unique id for a tee-time row (matches the throwaway id
// pattern used elsewhere in the quoting flow).
const generateRowID = () => Math.random().toString(36).substr(2, 9)

// Per-round tee-time editor. Display-only data (no pricing impact) - the fee
// band still drives the green-fee price; these are the human-readable "here's
// what we can offer" times shown on the quote PDF and itinerary preview.
//
// `teeTimes` is an array of { _id, date, time } where date and time are both
// stored as millis (or null). `onChange` is called with the updated array on
// every add/remove/edit. `label` titles the round.
export default function TeeTimes({ label, teeTimes = [], onChange }) {
	// Add a fresh empty row to the list
	const addRow = () => {
		onChange([...teeTimes, { _id: generateRowID(), date: null, time: null }])
	}

	// Remove the row at the given index
	const removeRow = (index) => {
		onChange(teeTimes.filter((_, rowIndex) => rowIndex !== index))
	}

	// Update a single field on the row at the given index
	const updateRow = (index, field, value) => {
		const clonedRows = [...teeTimes]
		clonedRows[index] = { ...clonedRows[index], [field]: value }
		onChange(clonedRows)
	}

	return (
		<div className="package-tee-times">
			<div className="package-tee-times-header">
				<p>{label} tee times:</p>

				<div
					className="package-tee-times-add"
					onClick={addRow}>
					<PlusIcon />
					Add
				</div>
			</div>

			{teeTimes.length > 0 && (
				<div className="package-tee-times-rows">
					{teeTimes.map((row, index) => (
						<div
							className="package-tee-time-row"
							key={row._id}>
							<Datepicker
								value={row.date || null}
								onSelect={(millis) => updateRow(index, "date", millis)}
								placeholder="Date"
							/>

							<Timepicker
								value={row.time || null}
								onSelect={(millis) => updateRow(index, "time", millis)}
								placeholder="Tee time"
							/>

							<div
								className="package-tee-time-remove"
								onClick={() => removeRow(index)}>
								<TrashIcon />
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
